<template>
    <v-row justify="center">
        <v-col class="pa-0 shrink" v-for="(buttonData, i) in text" :key="i">
            <button class="switcher" :class="{'first': i==0, 'last': i==(text.length)-1}" :style="getStyle(buttonData.name, i)" @click="$emit('switch', buttonData.name)">{{$t(buttonData.displayName)}}</button>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        name: 'ButtonSwitcher',
        props: {
            selected: { type: String, required: true },
            text: { type: Array, required: true },
            selectedTheme: { type: Object, default: function() {
                return {
                    'background-color': '#c6d4dc',
                    'color': '#fff',
                    'font-size': '10px',
                    'height': '48px',
                    'width': '170px',
                }
            }},
            unselectedTheme: { type: Object, default: function() {
                return {
                    'background-color': '#fff',
                    'color': '#c6d4dc',
                    'font-size': '10px',
                    'height': '48px',
                    'width': '170px',
                }
            }},
        },
        methods: {
            getStyle: function(buttonText, i) {
                if (this.selected.toLowerCase() === buttonText) {
                    return i == 0 ? Object.assign({}, this.selectedTheme, this.getFirstSelectedBorder) : this.selectedTheme
                }
                else {
                    return i == 0 ? Object.assign({}, this.unselectedTheme, this.getFirstUnselectedBorder) : this.unselectedTheme
                }
            }
        },
        computed: {
            getFirstSelectedBorder: function () {
                return {'border-left': this.selectedTheme['border-right']}
            },
            getFirstUnselectedBorder: function () {
                return {'border-left': this.unselectedTheme['border-right']}
            }
        }
    }
</script>


<style scoped>
.switcher {
  text-transform: uppercase;
  padding: 0 5px;
  white-space: nowrap;
}
.switcher:focus {
  outline: none;
}
.first {
  border-radius: 3.5px 0px 0px 3.5px;
}
.last {
  border-radius: 0px 3.5px 3.5px 0px;
}
</style>